import { ThemeColors } from "@insite/mobius/globals/baseTheme";
import { safeColor } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import RecursivePartial from "@insite/mobius/utilities/RecursivePartial";
import { css } from "styled-components";

export const fontFamilyHeader = "'myriad-pro-condensed', 'myriad-pro-condensed-fallback', sans-serif";
export const fontFamily = "'myriad-pro', 'myriad-pro-fallback', sans-serif";

// in case of needing it
export const secondaryFontFamily = "'Barlow Condensed', 'myriad-pro-condensed-fallback', sans-serif";

export const mediaQueriesBP = {
    maxSM: "@media screen and (max-width: 424px)",
    minSM: "@media screen and (min-width: 425px)",

    maxMD: "@media screen and (max-width: 767px)",
    minMD: "@media screen and (min-width: 768px)",

    maxLG: "@media screen and (max-width: 1023px)",
    minLG: "@media screen and (min-width: 1024px)",

    maxXLG: "@media screen and (max-width: 1199px)",
    minXLG: "@media screen and (min-width: 1200px)",

    minMDMaxLg: "@media screen and (min-width: 768px) and (max-width: 1023px)",
};

export const calcInitial = "calc(((100vw - 100%) / 2) * -1)";
export const calcInitialWidth = "calc(100vw - 1.1rem)"; // padding page 15px

export const isWindows = () => {
    if (typeof navigator === "undefined") {
        return false;
    }
    return navigator.userAgent.indexOf("Windows") !== -1;
};

export const colorPalette: RecursivePartial<ThemeColors> = {
    primary: {
        main: "#e82011",
        contrast: "#3e0013",
    },
    secondary: {
        main: "#006496",
    },
    success: {
        main: "#019d05",
        contrast: "#e5ffef",
    },
    info: {
        main: "#0077B6",
    },
    danger: {
        main: "#d83300",
        contrast: "#ffe5e5",
    },
    warning: {
        main: "#ffcc00",
    },
    text: {
        main: "#4A4A4A",
        link: "#e82011",
        disabled: "#74797C",
    },
    common: {
        primaryalt: {
            main: "#fff",
            contrast: "#e82011",
        },
        background: "#fff",
        border: "#dddddd",
        disabled: "#d3d3d3",
        global: {
            white: "#fff",
            black: "#000",

            // primary

            // secondary

            // grays
            gray01: "#4a4a4a",
            gray02: "#74797c",
            gray03: "#dddddd",
            gray04: "#f4f4f4",
            gray05: "#f6f9f8",
            gray06: "#F2F2F2",

            // ui
            uigreen: "#008768",
            uired: "#de3502",
            uiyellow: "#ffcc00",
            uigreenchart: "#009660",
            uiyellowchart: "#f8b241",
            uipurplechart: "#7263ca",

            // header
            headerbg: "#e82011",

            // Client specific colors
            maroon: "#3E0013",
        },
    } as any,
};

export const colorStrings = {
    primaryMain: "primary.main",
    primaryMainContrast: "primary.contrast",
    secondaryMain: "secondary.main",
    successMain: "success.main",
    dangerMain: "danger.main",
    dangerContrast: "danger.contrast",
    warningMain: "warning.main",
    infoMain: "info.main",
    commonAccent: "common.accent",
    commonBackground: "common.background",
    commonBorder: "common.border",
    textMain: "text.main",
    textLink: "text.link",
    textDisabled: "text.disabled",
    common: "common",
    commonDisabled: "common.disabled",

    commonPrimaryAlt: "common.primaryAlt",
    commonGlobalWhite: "common.global.white",
    commonGlobalBlack: "common.global.black",
    commonGlobalGray01: "common.global.gray01",
    commonGlobalGray02: "common.global.gray02",
    commonGlobalGray03: "common.global.gray03",
    commonGlobalGray04: "common.global.gray04",
    commonGlobalGray05: "common.global.gray05",
    commonGlobalGray06: "common.global.gray06",
    commonGlobalHeaderBg: "common.global.headerBg",
    commonGlobalUiGreen: "common.global.uiGreen",
    commonGlobalUiRed: "common.global.uiRed",
    commonGlobalUiYellow: "common.global.uiYellow",
    commonGlobalUiGreenChart: "common.global.uiGreenChart",
    commonGlobalUiYellowChart: "common.global.uiYellowChart",
    commonGlobalUiPurpleChart: "common.global.uiPurpleChart",

    commonGlobalMaroon: "common.global.maroon",
};

export const manualStyles = {
    headerMobileSelected: css`
        background: #e8201140;
        background: ${safeColor(getColor(colorStrings.primaryMain)).rgb().alpha(0.25).toString()};
        color: #222;
        color: ${getColor(colorStrings.textMain)};
    `,
};
